import React from 'react';
import { LayoutDashboard, Activity } from 'lucide-react';
import StatsCards from './StatsCards';
import BookingsTable from './BookingsTable';
import * as XLSX from 'xlsx';

export default function BookingsPage({ bookings, onDelete, onEdit }) {

function exportToExcel(bookings) {
  const filtered = bookings.map(({ name, phone, email, gender, created_at, notes, status }) => ({
    "الاسم": name,
    "الهاتف": phone,
    "البريد الإلكتروني": email,
    "الجنس": gender,
    "تاريخ الإنشاء": new Date(created_at).toLocaleDateString(),
    "ملاحظات": notes,
    "الحالة": status,
  }));

  const ws = XLSX.utils.json_to_sheet(filtered);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "الحجوزات");
  XLSX.writeFile(wb, "تقرير_الحجوزات.xlsx");
}

  return (
    <div className="bookings-section">
      <div className="section-header">
        <div className="section-title">
          <div className="section-icon"><LayoutDashboard size={24} /></div>
          <div><h2>إدارة الحجوزات</h2><p>إدارة جميع حجوزات المرضى والمواعيد</p></div>
        </div>
        <div className="section-actions">
          <button className="btn-primary" onClick={() => exportToExcel(bookings)}>
            <Activity size={16} />
            <span>تصدير التقرير</span>
          </button>
        </div>
      </div>
      <StatsCards bookings={bookings} />
      <BookingsTable bookings={bookings} onDelete={onDelete} onEdit={onEdit} />

    </div>

  );
}
